import { core } from '../../../helpers';
import { RollerShutterConfiguration } from '../../RollerShutterConfiguration';
import { RollerShutter } from '../../parts/roller_shutter/RollerShutter';
import { Color, ColorId } from '../../parts/common/Colors';
import { MosquitoConfiguration } from '../../MosquitoConfiguration';

/**
 * Przeniesienie profili rolet do profili
 */
export function changesInVersion6(
    oldConfiguration: MosquitoConfiguration,
    dataRequiredToUpdate: {
        windowColorRalsMap: Record<number | string, number>;
    }
) {
    const configuration = core.copy(oldConfiguration);
    if (configuration.colors) {
        Object.keys(configuration.colors).forEach((c: keyof MosquitoConfiguration['colors']) => {
            if (
                configuration.colors[c]
                && configuration.colors[c] != null
                && configuration.colors[c].id in dataRequiredToUpdate.windowColorRalsMap
            ) {
                updateColorId(configuration.colors[c]);
            }
        });
    }

    return configuration;

    function updateColorId(color: Color | ColorId) {
        if (color.RAL) {
            color.id = dataRequiredToUpdate.windowColorRalsMap[color.id] || color.id;
        }
    }
}
